import React from 'react';

export default function LearningTags({ item }) {
  if (!item) return null;
  return (
    <div className="learning-tags">
      {item.topic && <span className="learning-tag">{item.topic}</span>}
      {item.subCategory2 && <span className="learning-tag learning-tag--muted">{item.subCategory2}</span>}
      {item.subCategory1 && <span className="learning-tag learning-tag--muted">{item.subCategory1}</span>}
    </div>
  );
}
